module.exports = __webpack_public_path__ + "static/media/fa-solid-900.96dc3d20.svg";